"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.aFlatMap = void 0;
const a_map_1 = require("./a_map");
/**
 * Async Flay Map function
 *
 * @export
 * @template T
 * @template R
 * @param {T[]} elements
 * @param {CallBackFlatMap<T, R>} cb
 * @returns {Promise<R[]>}
 */
function aFlatMap(elements, cb) {
    return __awaiter(this, void 0, void 0, function* () {
        const results = yield a_map_1.aMap(elements, cb);
        return results.reduce((a, r) => (Array.isArray(r) ? a.concat(...r) : a.concat(r)), []);
    });
}
exports.aFlatMap = aFlatMap;
//# sourceMappingURL=a_flat_map.js.map